import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerCompanyNameFilter',
  pure: false
})
export class CustomerCompanyNameFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValue: string): any {
    if (!customerList || !filterValue) {
      return customerList;
    }
    const normalizedFilterValue = filterValue.toLowerCase();
    return customerList.filter(customer =>
      customer.CompanyName.toLowerCase().indexOf(normalizedFilterValue) !== -1 ||
      customer.Name.toLowerCase().indexOf(normalizedFilterValue) !== -1 ||
      customer.Surname.toLowerCase().indexOf(normalizedFilterValue) !== -1
    );
  }

}
